import { GQLCartFragment, GQLOperationalSettingsFragment } from '@theprintbar/graphql';
import { getCartPrice, getCurrencyString } from '@theprintbar/shared';

interface CartTaxesProps {
	settings: GQLOperationalSettingsFragment;
	cart: GQLCartFragment;
}

export function CartTaxes({ settings, cart }: CartTaxesProps) {
	return (
		<div className="font-normal text-xs lg:col-span-7 flex-1">
			<p>All prices are in AUD</p>
			<p>*Relevant taxes included for Aus orders</p>
			<p>**Some prices have been rounded to two decimal places for display purposes only</p>
		</div>
	);
}
